import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import "../Student_New/UserApplications.scss";
// import "../Student_New/Jobs.scss";
import PropagateLoader from "react-spinners/PropagateLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HiOutlinePencilAlt } from "react-icons/hi";
import { IoIosArrowForward, IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { MONTH_DETAILS } from "../data";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "react-select";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Grid, Tooltip, Typography } from "@mui/material";
import "./AdminDashboard.css";
import { LuClipboardEdit } from "react-icons/lu";
import { Spinner } from "react-bootstrap";
import { verified, cross, plusIcon } from "../../assets";
import { useDispatch, useSelector } from "react-redux";
import { loginUserForAdminCandidate } from "../../actions/userActions";
import { RiDeleteBinLine } from "react-icons/ri";
import Popup from "reactjs-popup";
import Pagination from "../Student_New/PaginationWithLastButton";
import PaginationWithLastButton from "../Student_New/PaginationWithLastButton";
import CountryCodeDropDownForProfile from "../Employer/CountryCodeDropDownForProfile";
// import { Button, Grid, MenuItem, Pagination as MuiPagination, TextField,  } from "@mui/material";

function AdminCandidates() {
    const [currentPage, setCurrentPage] = useState(1);
    const [candidateData, setCandidateData] = useState("");
    const [totalItem, setTotalItem] = useState(0);
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);
    const [sortByJobsApplied, setSortByJobsApplied] = useState(null);
    const [sortByJobsRejected, setSortByJobsRejected] = useState(null);
    const [sortByJobsShortlisted, setSortByJobsShortlisted] = useState(null);
    const [sortByJobsHired, setSortByJobsHired] = useState(null);
    const [sortField, setSortField] = useState(null); // State for sorting field
    const [sortOrder, setSortOrder] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loginType, setLoginType] = useState("User");
    const { isAuthenticated, user } = useSelector((state) => state.user);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(null);
    const borderRemoveRef = useRef(null);
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [currentSearchTerm, setCurrentSearchTerm] = useState("");
    const [sessionId, setSessionId] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [showOtpActions, setShowOtpActions] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [otp, setOtp] = useState({
        digitOne: "",
        digitTwo: "",
        digitThree: "",
        digitFour: "",
    });
    const [profiles, setProfiles] = useState([]);
    const [specializations, setSpecializations] = useState({});
    const [loadingSpecializations, setLoadingSpecializations] = useState({});
    const [timer, setTimer] = useState(30);
    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const [sortLoading, setSortLoading] = useState(false)
    const inputRefs = useRef([]);
    const startTimer = () => {
        setIsResendDisabled(true);
        setTimer(30);

        const countdown = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(countdown);
                    setIsResendDisabled(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };
    useEffect(() => {
        const getAllProfiles = async () => {
            const response = await axios.get("/api/data/project-category");
            setProfiles(response.data || []);
        };

        getAllProfiles();
    }, []);


    const fetchSpecializations = async (profileCategory, index) => {
        setLoadingSpecializations((prev) => ({ ...prev, [index]: true }));

        try {
            const encodedCategory = encodeURIComponent(profileCategory);
            const response = await axios.get(`/api/data/get-specialization?profileCategory=${encodedCategory}`);

            setSpecializations((prev) => ({
                ...prev,
                [profileCategory]: response.data || [],
            }));
        } catch (error) {
            toast.error("Failed to load specializations");
        } finally {
            setLoadingSpecializations((prev) => ({ ...prev, [index]: false }));
        }
    };

    const handleCandidateProfileSelect = (selectedOption, index) => {
        if (!selectedOption) return;

        fetchSpecializations(selectedOption.value, index);

        const updated = candidate.profileCategories.map((cat, i) =>
            i === index
                ? { ...cat, profile: selectedOption.value, specializations: [] }
                : cat
        );

        setCandidate({
            ...candidate,
            profileCategories: updated,
        });
    };


    const handleLogin = async (userId) => {
        if (loginType === "User") {
            // Assuming loginUser is an action creator
            await dispatch(loginUserForAdminCandidate(userId, loginType));
            localStorage.setItem("userType", loginType);
            localStorage.setItem("userLoggedIn", true);
            const userInfo = await axios.get("/api/user/me", {
                headers: {
                    "Content-Type": "application/json",
                    token: localStorage.getItem("token"),
                },
            });
            const basicDetails = {
                name: userInfo?.data?.user?.name,
                email: userInfo?.data?.user?.email,
            };
            localStorage.setItem("basicDetails", JSON.stringify(basicDetails));
            navigate("/");
        }
    };

    useEffect(() => {
        if (localStorage.getItem("token")) {
            if (user?.role === "User") {
                navigate("/");
            } else if (user?.role === "Employer") {
                navigate("/employerApplication/Internship");
            }
        }
    }, [isAuthenticated, user, navigate]);


    const GetCandidateData = async (searchInput = "", sortFieldParam = null, sortOrderParam = null) => {
        setLoading(true);

        try {
            const { data } = await axios.post("/api/user/getUserDataForAdmin", {
                searchInput,
                page: searchInput ? 1 : currentPage, // Always start from page 1 when searching
                pageSize: 20,
                sortBy: sortFieldParam !== null ? sortFieldParam : sortField,
                sortOrder: sortOrderParam !== null ? sortOrderParam : sortOrder,
                isSearch: searchInput ? true : false // Add flag to indicate search operation
            });

            setLoading(false);

            // If this was a search operation, reset to page 1
            if (searchInput) {
                setCurrentPage(1);
            }

            // Check if we need to handle client-side sorting for special fields
            let processedData = data.data;

            if (["jobsRejected", "jobsApplied", "jobsShortlisted", "jobsHired", "fixedJobs", "hourlyJobs", "connectSpent", "connectCredit", "viewingFreelancer"].includes(sortField)) {
                processedData = [...processedData].sort((a, b) => {
                    let valueA, valueB;

                    if (sortField === "jobsApplied") {
                        valueA = a.appliedJobs ? a.appliedJobs.length : 0;
                        valueB = b.appliedJobs ? b.appliedJobs.length : 0;
                    } else if (sortField === "jobsRejected") {
                        valueA = a.appliedJobs ? a.appliedJobs.filter(job => job.status === "NotIntrested").length : 0;
                        valueB = b.appliedJobs ? b.appliedJobs.filter(job => job.status === "NotIntrested").length : 0;
                    } else if (sortField === "jobsShortlisted") {
                        valueA = a.appliedJobs ? a.appliedJobs.filter(job => job.status === "Shortlisted").length : 0;
                        valueB = b.appliedJobs ? b.appliedJobs.filter(job => job.status === "Shortlisted").length : 0;
                    } else if (sortField === "jobsHired") {
                        valueA = a.appliedJobs ? a.appliedJobs.filter(job => job.status === "Hired").length : 0;
                        valueB = b.appliedJobs ? b.appliedJobs.filter(job => job.status === "Hired").length : 0;
                    } else if (sortField === "fixedJobs") {
                        valueA = a.appliedJobs ? a.appliedJobs.filter(appliedJob => appliedJob.job && appliedJob.job.opportunityType === "Fixed Cost").length : 0;
                        valueB = b.appliedJobs ? b.appliedJobs.filter(appliedJob => appliedJob.job && appliedJob.job.opportunityType === "Fixed Cost").length : 0;
                    } else if (sortField === "hourlyJobs") {
                        valueA = a.appliedJobs ? a.appliedJobs.filter(appliedJob => appliedJob.job && appliedJob.job.opportunityType === "Hourly").length : 0;
                        valueB = b.appliedJobs ? b.appliedJobs.filter(appliedJob => appliedJob.job && appliedJob.job.opportunityType === "Hourly").length : 0;
                    } else if (sortField === "connectSpent") {
                        valueA = a.connectSpent ? a.connectSpent : 0;
                        valueB = b.connectSpent ? b.connectSpent : 0;
                    } else if (sortField === "connectCredit") {
                        valueA = a.connectCredit ? a.connectCredit : 0;
                        valueB = b.connectCredit ? b.connectCredit : 0;
                    } else if (sortField === "viewingFreelancer") {
                        valueA = a.connectSpentJobSeeker ? a.connectSpentJobSeeker : 0;
                        valueB = b.connectSpentJobSeeker ? b.connectSpentJobSeeker : 0;
                    }
                    // Apply sorting direction
                    return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
                });
            }
            setCandidateData(processedData);
            setTotalPages(data.totalPages);
            setTotalItem(data.totalItems);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data || "An error occurred", {
                style: {
                    padding: "18px",
                },
            });
        }
    };

    // Helper functions for job counting
    const countHourlyJobs = (appliedJobs) => {
        return appliedJobs?.filter(job => job.job?.opportunityType === "Hourly").length || 0;
    };

    const countFixedCost = (appliedJobs) => {
        return appliedJobs?.filter(job => job.job?.opportunityType === "Fixed Cost").length || 0;
    };

    const countRejectedJobs = (appliedJobs) => {
        return appliedJobs?.filter(job => job.status === "NotIntrested").length || 0;
    };

    const countShortlistedJobs = (appliedJobs) => {
        return appliedJobs?.filter(job => job.status === "Shortlisted").length || 0;
    };

    const countHiredJobs = (appliedJobs) => {
        return appliedJobs?.filter(job => job.status === "Hired").length || 0;
    };

    // Function to handle sorting
    // const handleSort = (field, order) => {
    //     setSortField(field);
    //     setSortOrder(order);
    //     // No need to call API for sorting since we'll do it on the frontend
    // };

    // Function to get sorted data based on current sort field and order
    const getSortedData = () => {
        if (!candidateData || candidateData.length === 0) return [];

        const sortedData = [...candidateData]; // Create a copy to avoid mutating state

        switch (sortField) {
            case "hourlyJobs":
                sortedData.sort((a, b) => {
                    const countA = countHourlyJobs(a.appliedJobs);
                    const countB = countHourlyJobs(b.appliedJobs);
                    return sortOrder === "asc" ? countA - countB : countB - countA;
                });
                break;

            case "fixedJobs":
                sortedData.sort((a, b) => {
                    const countA = countFixedCost(a.appliedJobs);
                    const countB = countFixedCost(b.appliedJobs);
                    return sortOrder === "asc" ? countA - countB : countB - countA;
                });
                break;

            case "jobsRejected":
                sortedData.sort((a, b) => {
                    const countA = countRejectedJobs(a.appliedJobs);
                    const countB = countRejectedJobs(b.appliedJobs);
                    return sortOrder === "asc" ? countA - countB : countB - countA;
                });
                break;

            case "jobsShortlisted":
                sortedData.sort((a, b) => {
                    const countA = countShortlistedJobs(a.appliedJobs);
                    const countB = countShortlistedJobs(b.appliedJobs);
                    return sortOrder === "asc" ? countA - countB : countB - countA;
                });
                break;

            case "jobsHired":
                sortedData.sort((a, b) => {
                    const countA = countHiredJobs(a.appliedJobs);
                    const countB = countHiredJobs(b.appliedJobs);
                    return sortOrder === "asc" ? countA - countB : countB - countA;
                });
                break;

            case "connectCredit":
                sortedData.sort((a, b) => {
                    const creditA = parseInt(a.connectCredit || 0);
                    const creditB = parseInt(b.connectCredit || 0);
                    return sortOrder === "asc" ? creditA - creditB : creditB - creditA;
                });
                break;

            case "connectSpent":
                sortedData.sort((a, b) => {
                    const spentA = parseInt(a.connectSpent || 0);
                    const spentB = parseInt(b.connectSpent || 0);
                    return sortOrder === "asc" ? spentA - spentB : spentB - spentA;
                });
                break;

            default:
                // Default sorting by date added
                sortedData.sort((a, b) => {
                    const dateA = new Date(a.dataAdded);
                    const dateB = new Date(b.dataAdded);
                    return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
                });
        }

        return sortedData;
    };
    const getTotalData = async () => {
        try {
            const response = await axios.get("/api/user/getTotalUserAndJobs");
            setTotalData(response?.data);

        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getTotalData();
    }, [candidateData]);

    // useEffect(() => {
    //     GetCandidateData();
    // }, [sortField, sortOrder]);

    // useEffect(() => {
    //     // Only call GetCandidateData if it's not an active field sort
    //     // (active field sorting is handled directly in handleSort)
    //     if (sortField && sortField !== "active" &&
    //         !["jobsApplied", "jobsRejected", "phone", "minimumRate", "jobsShortlisted", "jobsHired", "fixedJobs", "hourlyJobs", "connectSpent", "connectCredit", "viewingFreelancer"].includes(sortField)) {
    //         GetCandidateData();
    //     }
    // }, [sortField, sortOrder, currentPage]);

    useEffect(() => {
        GetCandidateData(isSearchMode ? currentSearchTerm : "");
        window.scrollTo(0, 0);
    }, [currentPage]);

    // const handleSortnew = (field, direction) => {
    //     console.log(field, direction);
    //     setSortField(field);
    //     setSortOrder(direction);
    //     handleSort(field, direction); // Sort data manually
    // };
    const handleSort = async (field, order) => {
        setSortField(field);
        setSortOrder(order);
        const dataPhoneValue = (user) => {
            const countryCode = user?.resume?.PersonalDetails?.countryCode || user?.countryCode || "";
            const phone = user?.phone || "";

            return phone ? `${countryCode}${phone}`.trim() : "";
        };
        // For active field, let the backend handle it completely
        if (field === "active") {
            setCurrentPage(1);
            // Pass search term if in search mode
            await GetCandidateData(isSearchMode ? currentSearchTerm : "", field, order);
            return;
        }
        // Handle frontend sorting for job-related fields
        if (["jobsApplied", "jobsRejected", "jobsShortlisted", "jobsHired", "fixedJobs", "hourlyJobs", "connectSpent", "connectCredit", "viewingFreelancer"].includes(field)) {
            const sortedData = [...candidateData].sort((a, b) => {
                let valueA, valueB;

                if (field === "jobsApplied") {
                    valueA = a.appliedJobs ? a.appliedJobs.length : 0;
                    valueB = b.appliedJobs ? b.appliedJobs.length : 0;
                } else if (field === "jobsRejected") {
                    valueA = countRejectedJobs(a.appliedJobs);
                    valueB = countRejectedJobs(b.appliedJobs);
                } else if (field === "jobsShortlisted") {
                    valueA = countShortlistedJobs(a.appliedJobs);
                    valueB = countShortlistedJobs(b.appliedJobs);
                } else if (field === "jobsHired") {
                    valueA = countHiredJobs(a.appliedJobs);
                    valueB = countHiredJobs(b.appliedJobs);
                } else if (field === "fixedJobs") {
                    valueA = countFixedCost(a.appliedJobs);
                    valueB = countFixedCost(b.appliedJobs);
                } else if (field === "hourlyJobs") {
                    valueA = countHourlyJobs(a.appliedJobs);
                    valueB = countHourlyJobs(b.appliedJobs);
                } else if (field === "minimumRate") {
                    valueA = Number(a?.resume?.PersonalDetails?.minimumRate) || 0;
                    valueB = Number(b?.resume?.PersonalDetails?.minimumRate) || 0;
                    if (order === "asc") {
                        if (valueA && !valueB) return -1;
                        if (!valueA && valueB) return 1;
                        return valueA - valueB;
                    } else {
                        if (valueA && !valueB) return 1;
                        if (!valueA && valueB) return -1;
                        return valueB - valueA;
                    }
                } else if (field === "phone") {
                    valueA = dataPhoneValue(a);
                    valueB = dataPhoneValue(b);

                    if (order === "asc") {
                        if (valueA && !valueB) return -1;
                        if (!valueA && valueB) return 1;
                        return valueA.localeCompare(valueB);
                    } else {
                        if (valueA && !valueB) return 1;
                        if (!valueA && valueB) return -1;
                        return valueB.localeCompare(valueA);
                    }
                }

                return order === "asc" ? valueA - valueB : valueB - valueA;
            });

            // Apply pagination after sorting
            // const startIndex = (currentPage - 1) * 20;
            // setCandidateData(sortedData.slice(startIndex, startIndex + 20));
            setCandidateData(sortedData);
        } else {
            // Backend sorting for other fields - pass search term if in search mode
            await GetCandidateData(isSearchMode ? currentSearchTerm : "", field, order);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    useEffect(() => {
        // Pass the current search term if in search mode
        GetCandidateData(isSearchMode ? currentSearchTerm : "");
        window.scrollTo(0, 0);
    }, [currentPage]);



    // ACTIVE DEACTIVE OPTION:

    const [id, setId] = useState("");
    const [userStatus, setUserStatus] = useState("");

    const idSelector = (_id) => {
        setId(_id);
    };

    const ActiveUser = async () => {
        window.scrollTo(0, 0);
        setLoading(true);
        try {
            const { data } = await axios.post("/api/user/activedeactive", {
                id: id,
                status: "active",
            });
            // GetCandidateData();
            // setCandidateData(candidateData?.map(user => user._id === id ? { ...user, active: "Active" } : user));
            const userIndex = candidateData.findIndex((user) => user._id === id);
            // If the user is found, update the active field directly
            if (userIndex !== -1) {
                candidateData[userIndex].active = true;
            }
            toast.success("User is active now");
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
            toast.error(error.response.data, {
                style: {
                    padding: "18px",
                },
            });
        }
    };

    const DeActiveUser = async () => {
        window.scrollTo(0, 0);
        setLoading(true);
        try {
            const { data } = await axios.post("/api/user/activedeactive", {
                id: id,
                status: "de-active",
            });
            // GetCandidateData();
            // setCandidateData(candidateData?.map(user => user._id === id ? { ...user, active: "De-active" } : user));
            const userIndex = candidateData.findIndex((user) => user._id === id);
            // If the user is found, update the active field directly
            if (userIndex !== -1) {
                candidateData[userIndex].active = false;
            }
            toast.success("User is not active now");
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
            toast.error(error.response.data, {
                style: {
                    padding: "18px",
                },
            });
        }
    };

    // SEARCH OPTION:

    const [search, setSearch] = useState("");
    const handleSearchInput = (e) => {
        setSearch(e.target.value);
    };

    // const handleSearch = () =>{
    //   GetCandidateData();
    //   setSearch("");
    // }
    const handleSearch = () => {
        // Reset sorting when searching
        setSortField(null);
        setSortOrder(null);
        setCurrentPage(1);

        if (search.trim() !== "") {
            setIsSearchMode(true);
            setCurrentSearchTerm(search.trim());
            GetCandidateData(search.trim());
            setSearch("");
        } else {
            setIsSearchMode(false);
            setCurrentSearchTerm("");
            GetCandidateData();
            setSearch("");
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    // FOR AUTHENTICATION
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        if (!localStorage.getItem("token") || !localStorage.getItem("userType") || localStorage.getItem("userType") !== "Admin") {
            navigate("/admin_login");
        }
    });
    //  END

    const initialForm = {
        _id: "",
        resumeId: "",
        name: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        countryCode: "",
        city: "",
        address: "",
        verified: false,
        minimumRate: "",
        professionalTitle: "",
        profileSummary: "",
        availability: "",
        videoIntroduction: "",
        photo: "",
        oldPhone: "",
        oldCountryCode: "",
        profileCategories: [{ id: 1, profile: null, specializations: [] }],
    };

    const [candidate, setCandidate] = useState(initialForm);
    useEffect(() => {
        borderRemoveRef.current.scrollTop = 0;
    }, [candidate._id]);

    const fetchData = async (_id) => {
        borderRemoveRef.current.scrollTop = 0;

        const response = await fetch(`/api/admin/getUserToUpdatedata/${_id}`);

        if (!response.ok) {
            throw new Error("Failed to fetch user data");
        }
        const data = await response.json();
        const userData = data.user;
        const pd = userData?.resume?.PersonalDetails || {};
        const fullName = userData?.name || "";
        const splitName = fullName.trim().split(" ");
        const firstNameFallback = splitName[0] || "";
        const lastNameFallback = splitName.slice(1).join(" ") || "";

        setCandidate({
            _id: userData._id,
            resumeId: userData?.resume?._id || "",
            name: userData.name || "",
            firstName: pd.firstName || firstNameFallback,
            lastName: pd.lastName || lastNameFallback,
            email: pd.email || userData.email || "",
            phone: pd.phone || userData.phone || "",
            countryCode: pd.countryCode || userData.countryCode || "",
            city: userData.city || "",
            address: pd.address || userData.city || "",
            verified: pd.verified || false,
            minimumRate: pd.minimumRate || "",
            professionalTitle: pd.professionalTitle || "",
            profileSummary: pd.profileSummary || "",
            availability: pd.availability || userData.availability || "",
            videoIntroduction: pd.videoIntroduction || "",
            photo: pd.photo || "",
            profileCategories:
                pd.profileCategories?.length > 0
                    ? pd.profileCategories
                    : [{ id: 1, profile: null, specializations: [] }],
            oldPhone: pd.phone || userData.phone || "",
            oldCountryCode: pd.countryCode || userData.countryCode || "",
        });
        if (!userData?.resume?.PersonalDetails) {
            toast.info("Please complete full personal details");
        }
    };

    const handleUserChange = (e) => {
        setCandidate({
            ...candidate,
            [e.target.name]: e.target.value,
        });
    };

    const handleCandidatePhoneChange = (e) => {
        const value = e.target.value;

        setCandidate((prev) => ({
            ...prev,
            phone: value,
            verified: false,
        }));

        setIsVerified(false);

        if (value.length > 6) {
            setOtpSent(false);
            setShowOtpActions(true);
        } else {
            setShowOtpActions(false);
        }
    };


    const handleCandidateCountrySelect = (country) => {

        if (country === null) {
            setCandidate({
                ...candidate,
                countryCode: "",
                verified: false,
            });
        } else {
            setCandidate({
                ...candidate,
                countryCode: country.phone,
                verified: false,
            });
        }

        setIsVerified(false);
        setOtpSent(false);

        if (candidate.phone?.length > 6) {
            setShowOtpActions(true);
        }
    };
    const handlePhotoChangeForAdmin = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setCandidate((prev) => ({
                ...prev,
                photo: reader.result,
            }));
        };
        reader.readAsDataURL(file);
    };

    const handleCandidateProfileCategoryChange = (index, key, value) => {
        const updated = [...candidate.profileCategories];

        updated[index] = {
            ...updated[index],
            [key]: value,
        };

        setCandidate({
            ...candidate,
            profileCategories: updated,
        });
    };

    const addCandidateProfileCategory = () => {
        if (candidate.profileCategories.length >= 3) return;

        setCandidate({
            ...candidate,
            profileCategories: [
                ...candidate.profileCategories,
                {
                    id: Date.now(),
                    profile: "",
                    specializations: [],
                },
            ],
        });
    };

    const removeCandidateProfileCategory = (index) => {
        const updated = candidate.profileCategories.filter((_, i) => i !== index);
        setCandidate({
            ...candidate,
            profileCategories: updated.length
                ? updated
                : [{ id: 1, profile: "", specializations: [] }],
        });
    };

    // const handleUpdate = async () => {
    //     setLoading(true);
    //     if (!candidate.name) {
    //         setLoading(false);
    //         toast.error("Name is required!!");
    //     } else if (!candidate.phone) {
    //         setLoading(false);
    //         toast.error("Phone is required!!");
    //     } else if (!candidate.city) {
    //         setLoading(false);
    //         toast.error("City is required!!");
    //     } else if (candidate.availability == "Select availability") {
    //         setLoading(false);
    //         toast.error("Select availability!!");
    //     } else {
    //         // console.log(candidate.email, "email");
    //         try {
    //             const { data } = await axios.post("/api/admin/udateuserdatafromadminsite", {
    //                 name: candidate.name,
    //                 phone: candidate.phone,
    //                 city: candidate.city,
    //                 availability: candidate.availability,
    //                 email: candidate.email,
    //             });
    //             setLoading(false);
    //             toast.success("User Updated Successfully!", {
    //                 style: {
    //                     // padding: "18px",
    //                 },
    //             });
    //             document.querySelector(".btn-close").click();
    //             GetCandidateData();
    //             setCandidate({
    //                 name: "",
    //                 phone: "",
    //                 city: "",
    //                 availability: "Select availability",
    //             });
    //         } catch (error) {
    //             setLoading(false);
    //             toast.error(error.response.data, {
    //                 style: {
    //                     padding: "18px",
    //                 },
    //             });
    //         }
    //     }
    // };

    const sendOtpForAdminCandidate = async () => {
        if (!candidate.countryCode || !candidate.phone) {
            toast.error("Please enter country code and phone number");
            return;
        }

        setLoading(true);

        try {
            const blockedCheck = await axios.get("/api/user/blocked-credential/check", {
                params: {
                    phone: String(candidate.phone).trim(),
                    countryCode: String(candidate.countryCode).replace("+", "").trim(),
                },
            });

            if (blockedCheck.data.blocked) {
                setLoading(false);
                toast.error(
                    blockedCheck.data.message ||
                    "This phone number is blocked and cannot be used."
                );
                return;
            }
            const response = await axios.post("/api/user/getotpforuser", {
                phone: String(candidate.phone).trim(),
                countryCode: String(candidate.countryCode).replace("+", "").trim(),
                saveData: true,
            });

            if (response.data.sessionId) {
                setSessionId(response.data.sessionId);
                setOtpSent(true);
                startTimer();
                toast.success("OTP sent successfully");
            }
        } catch (error) {
            console.log(error.response?.data);
            toast.error(error?.response?.data?.error || "Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const verifyOtpForAdminCandidate = async () => {
        const validOtp = `${otp.digitOne}${otp.digitTwo}${otp.digitThree}${otp.digitFour}`;

        if (validOtp.length !== 4) {
            toast.error("Please enter valid OTP");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post("/api/user/verifyotpforuser", {
                sessionId,
                otp: validOtp,
                phone: candidate.phone,
                countryCode: candidate.countryCode,
                userType: 0,
            });

            if (response.status === 200) {
                setIsVerified(true);
                setCandidate((prev) => ({
                    ...prev,
                    verified: true,
                }));
                setShowOtpActions(false);
                toast.success("Phone verified successfully");
            }
        } catch (error) {
            toast.error(error?.response?.data?.error || error?.response?.data?.message?.message || "OTP verification failed");
        } finally {
            setLoading(false);
        }
    };

    const handleOtpChange = (e, digit, index) => {
        const value = e.target.value.replace(/\D/g, "");

        setOtp((prev) => ({
            ...prev,
            [digit]: value,
        }));
        if (value && index < 3) {
            inputRefs.current[index + 1]?.focus();
        }
        if (!value && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handleUpdate = async () => {
        setLoading(true);
        if (!candidate.firstName) {
            setLoading(false);
            toast.error("Enter first name");
            return;
        }

        if (!candidate.lastName) {
            setLoading(false);
            toast.error("Enter last name");
            return;
        }

        if (!candidate.minimumRate) {
            setLoading(false);
            toast.error("Enter minimum rate");
            return;
        }

        if (!candidate.professionalTitle) {
            setLoading(false);
            toast.error("Enter professional title");
            return;
        }
        if (!candidate.verified) {
            setLoading(false);
            toast.error("Please verify phone number first");
            return;
        }

        if (!candidate.phone) {
            setLoading(false);
            toast.error("Enter phone number");
            return;
        }

        if (!candidate.address) {
            setLoading(false);
            toast.error("Enter location");
            return;
        }

        if (!candidate.availability) {
            setLoading(false);
            toast.error("Select availability");
            return;
        }

        try {
            await axios.put(
                `/api/admin/updateFreelancerPersonalDetails/${candidate._id}`,
                {
                    firstName: candidate.firstName,
                    lastName: candidate.lastName,
                    email: candidate.email,
                    phone: candidate.phone,
                    countryCode: candidate.countryCode,
                    verified: candidate.verified,
                    address: candidate.address,
                    availability: candidate.availability,
                    photo: candidate.photo,
                    professionalTitle: candidate.professionalTitle,
                    videoIntroduction: candidate.videoIntroduction,
                    minimumRate: candidate.minimumRate,
                    profileCategories: candidate.profileCategories,
                    profileSummary: candidate.profileSummary,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        token: localStorage.getItem("token"),
                    },
                }
            );
            const isPhoneChanged =
                String(candidate.phone || "").trim() !== String(candidate.oldPhone || "").trim() ||
                String(candidate.countryCode || "").trim() !== String(candidate.oldCountryCode || "").trim();

            if (isPhoneChanged) {
                const oldPhone = String(candidate.oldPhone || "").trim();
                const oldCountryCode = String(candidate.oldCountryCode || "").replace("+", "").trim();

                if (oldPhone && oldCountryCode) {
                    await axios.post("/api/user/blocked-credential", {
                        oldPhone,
                        oldCountryCode,
                        phone: String(candidate.phone).trim(),
                        countryCode: String(candidate.countryCode).replace("+", "").trim(),
                        role: "User",
                        reason: "Freelancer phone updated by admin",
                    });
                } else {
                    await axios.post("/api/user/blocked-credential", {
                        oldEmail: candidate.email,
                        email: candidate.email,
                        phone: String(candidate.phone).trim(),
                        countryCode: String(candidate.countryCode).replace("+", "").trim(),
                        role: "User",
                        reason: "Freelancer phone added by admin",
                    });
                }
            }
            setLoading(false);
            toast.success("User Updated Successfully!");
            document.querySelector(".btn-close").click();
            GetCandidateData();
            setCandidate(initialForm);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Something went wrong");
        }
    };

    const handleKeyDown3 = (e, id) => {
        if (e.key === "Enter") {
            e.preventDefault();
            const newConnectCredit = e.target.textContent.trim(); // Get the edited content
            handleBalanceUpdate(newConnectCredit, id); // Pass the new value and the id to the update function
        }
    };
    const handleBlur = (e, id) => {
        const newConnectCredit = e.target.textContent.trim(); // Get the edited content
        handleBalanceUpdate(newConnectCredit, id); // Pass the new value and the id to the update function
    };
    const handleBlur2 = (e, id) => {
        const newConnectSpent = e.target.textContent.trim();
        handleBalanceSpentUpdate(newConnectSpent, id);
    };

    const handleBalanceUpdate = async (newConnectCredit, id) => {
        // e.preventDefault();
        // setLoading(true);
        if (!newConnectCredit) {
            // setLoading(false);
            toast.error("Balance Connect is required!!");
        } else {
            try {
                const { data } = await axios.post("/api/admin/updatebalanceconnectadminemployee", {
                    // connectCredit:balanceConnect.connectCredit,
                    connectCredit: newConnectCredit,
                    // _id:balanceConnect._id
                    _id: id,
                });
                // setLoading(false);
                // toast.success("Balance Connect Updated Successfully!", {
                //   style: {
                //     // padding: "18px",
                //   },
                // });
                document.querySelector(".close2").click();
                const userIndex = candidateData.findIndex((user) => user._id === id);
                if (userIndex !== -1) {
                    candidateData[userIndex].connectCredit = newConnectCredit;
                }
                // GetEmployerData();
            } catch (error) {
                setLoading(false);
                toast.error(error.response.data, {
                    style: {
                        padding: "18px",
                    },
                });
            }
        }
    };
    const handleKeyDown4 = (e, id) => {
        if (e.key === "Enter") {
            e.preventDefault();
            const newConnectSpent = e.target.textContent.trim();
            handleBalanceSpentUpdate(newConnectSpent, id);
        }
    };
    const handleBalanceSpentUpdate = async (newConnectSpent, id) => {
        // e.preventDefault();
        // setLoading(true);
        if (!newConnectSpent) {
            // setLoading(false);
            toast.error("Connect Spent is required!!");
        } else {
            try {
                const { data } = await axios.post("/api/admin/updateconnectspentadminemployee", {
                    connectSpent: newConnectSpent,
                    _id: id,
                    // connectSpent:balanceConnect.connectSpent,
                    // _id:balanceConnect._id
                });
                // setLoading(false);
                // toast.success("Balance Connect Updated Successfully!", {
                //   style: {
                //     // padding: "18px",
                //   },
                // });
                document.querySelector(".close3").click();
                const userIndex = candidateData.findIndex((user) => user._id === id);
                if (userIndex !== -1) {
                    candidateData[userIndex].connectSpent = newConnectSpent;
                }
                // GetEmployerData();
            } catch (error) {
                setLoading(false);
                toast.error(error.response.data, {
                    style: {
                        padding: "18px",
                    },
                });
            }
        }
    };

    // console.log(countJobTypes(candidateData));

    const [showModal, setShowModal] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);

    const handleDeleteConfirmation = (id) => {
        setIdToDelete(id);
        setShowModal(true);
    };

    const handleConfirmDelete = async () => {
        await handleDeleteCandidate(idToDelete);
        setShowModal(false);
    };

    const handleCancelDelete = () => {
        setShowModal(false);
    };
    const handleDeleteCandidate = async (id) => {
        setLoading(true);
        try {
            await axios.post(`/api/admin/deleteUserFromAdminside/${id}`);

            const canIndex = candidateData.findIndex((job) => job._id === id);

            if (canIndex !== -1) {
                const updatedCanData = [...candidateData];
                updatedCanData.splice(canIndex, 1);
                setCandidateData(updatedCanData);
            }
            toast.success("User Deleted Successfully");
            setLoading(false);
            await axios.post("/api/admin/logDeleteAttempt", { userId: id });
        } catch (error) {
            console.error("Error deleting job:", error);
        }
    };

    return (
        <>
            <div className="my-applications">
                {loading ? (
                    <>
                        <div className="my-auto" style={{ textAlign: "center" }}>
                            <p
                                className="loaderLoader"
                                style={{
                                    color: "#4B92C8",
                                    fontWeight: "500",
                                    fontSize: "20px",
                                    marginLeft: "16px",
                                    marginBottom: "5px",
                                }}
                            >
                                Loading..
                            </p>
                            <PropagateLoader color={"#4B92C8"} loading={true} size={15} aria-label="Loading Spinner" data-testid="loader" style={{ marginLeft: "-4px" }} />
                        </div>
                    </>
                ) : (
                    <>
                        <p className="borderremove" style={{ color: "#494949", fontSize: "20px", fontWeight: "500", backgroundColor: "white", borderRadius: "10px", paddingLeft: "10%", paddingRight: "10%", paddingTop: "1%", paddingBottom: "1%", boxShadow: "0px 0px 15px 0px #00000025" }}>
                            Freelancer Details
                        </p>
                        <div
                            className="AdminSearchBox"
                            style={{
                                marginLeft: "auto",
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                            }}
                        >
                            <input
                                className="AdminSearchInput"
                                style={{ width: "460px" }}
                                type="text"
                                placeholder="Search by name, email, phone"
                                onChange={handleSearchInput}
                                value={search}
                                onKeyPress={handleKeyPress}
                            />
                            <button className="AdminSearchButton" onClick={handleSearch}>
                                Search
                            </button>
                        </div>
                        <div className="table-box table-responsive border borderremove px-0">
                            <table className="applications table" style={{ marginLeft: "-2px" }}>
                                <thead className="adminTableHead">
                                    <tr>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px" }}>Name</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px" }}>User Login</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "120px", cursor: "pointer" }}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "2px"
                                            }}>
                                                <span>Rate</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "minimumRate" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("minimumRate", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "minimumRate" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("minimumRate", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "140px" }}>Email</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>Phone</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "phone" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("phone", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "phone" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("phone", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "110px" }}>Location</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "110px" }}>User Since</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>Profile Status</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Show Only Active Users" style={{ fontSize: "1.3em", color: sortField === "active" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("active", "asc")} />
                                                    <IoMdArrowDropdown title="Show Only Inactive Users" style={{ fontSize: "1.3em", color: sortField === "active" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("active", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "100px" }}>#Edit Profile</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px" }}>#Delete Freelancer</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "210px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>#Hourly Project Applied</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "hourlyJobs" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("hourlyJobs", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "hourlyJobs" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("hourlyJobs", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "210px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>#Fixed Projects Applied</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "fixedJobs" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("fixedJobs", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "fixedJobs" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("fixedJobs", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "200px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>#Viewing Freelancer's Employer Contact</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "viewingFreelancer" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("viewingFreelancer", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "viewingFreelancer" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("viewingFreelancer", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>#Hourly/Fixed Rejected</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "jobsRejected" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("jobsRejected", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "jobsRejected" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("jobsRejected", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>#Hourly/Fixed Shortlisted</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "jobsShortlisted" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("jobsShortlisted", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "jobsShortlisted" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("jobsShortlisted", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "140px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>#Hourly/Fixed Hired</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "jobsHired" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("jobsHired", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "jobsHired" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("jobsHired", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>Balance #Connects</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "connectCredit" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("connectCredit", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "connectCredit" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("connectCredit", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px", cursor: "pointer" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                                <span>#Connects Spent All</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "connectSpent" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("connectSpent", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "connectSpent" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("connectSpent", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "200px" }}>Address</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px" }}>Identity</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px" }}>Billing Statement</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading2 ? (
                                        <>
                                            <Grid item xs={12} md={12} container justifyContent="center" alignItems="center" style={{ paddingLeft: "5%" }}>
                                                <div className=" mx-auto" style={{ marginBottom: "20px", marginTop: "20px", justifyContent: "center", justifyItem: "center", textAlign: "center" }}>
                                                    <ScaleLoader color={"#4B92C8"} loading={true} size={15} aria-label="Loading Spinner" data-testid="loader" />
                                                </div>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            {candidateData.length != 0 ? (
                                                <>
                                                    {candidateData.map((data, index) => (
                                                        <tr key={index} style={{ verticalAlign: "middle" }} className="AdminTableData">
                                                            <td
                                                                style={{
                                                                    fontSize: "14px",
                                                                    cursor: "pointer",
                                                                    minWidth: "190px",
                                                                    color: "#4B92C8",
                                                                    padding: "8px 8px",
                                                                    verticalAlign: "middle",
                                                                }}
                                                                className="tableheadingstyle1"
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "flex-start",
                                                                        gap: "6px",
                                                                        height: "100%",
                                                                        minHeight: "50px",
                                                                    }}
                                                                >
                                                                    {/* IMAGE LINK */}
                                                                    <a
                                                                        href={`/previewFreelancer/${data?.name}/${data?._id}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{
                                                                            textDecoration: "none",
                                                                            flexShrink: 0,
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                textAlign: "center",
                                                                                color: "#000",
                                                                                height: "50px",
                                                                                width: "50px",
                                                                                fontSize: "12px",
                                                                                border:
                                                                                    !data?.resume?.PersonalDetails?.photo?.url &&
                                                                                    "2px solid gray",
                                                                                borderRadius: "50%",
                                                                                paddingTop: "0px",
                                                                                marginRight: "2px",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                backgroundColor:
                                                                                    !data?.resume?.PersonalDetails?.photo?.url
                                                                                        ? "#e5e5e5"
                                                                                        : "transparent",
                                                                                overflow: "hidden",
                                                                            }}
                                                                        >
                                                                            {data?.resume?.PersonalDetails?.photo?.url ? (
                                                                                <img
                                                                                    src={data?.resume?.PersonalDetails?.photo?.url}
                                                                                    alt="Profile"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        objectFit: "cover",
                                                                                        borderRadius: "50%",
                                                                                        boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                                                                                        border: "2px solid white",
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <p
                                                                                    style={{
                                                                                        fontSize: "18px",
                                                                                        marginBottom: "0px",
                                                                                        color: "#000",
                                                                                        fontWeight: "500",
                                                                                        textTransform: "uppercase",
                                                                                    }}
                                                                                >
                                                                                    {data?.name?.slice(0, 1)}
                                                                                </p>
                                                                            )}
                                                                        </div>
                                                                    </a>

                                                                    {/* NAME LINK */}
                                                                    <Tooltip
                                                                        title={
                                                                            <Typography sx={{ fontSize: "16px" }}>
                                                                                {data.name}
                                                                            </Typography>
                                                                        }
                                                                        arrow
                                                                        disableHoverListener={data.name.length <= 12}
                                                                    >
                                                                        <a
                                                                            href={`/previewFreelancer/${data?.name}/${data?._id}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{
                                                                                textDecoration: "none",
                                                                                color: "#000",
                                                                                transition: "0.2s ease",
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.target.style.textDecoration = "underline";
                                                                                e.target.style.color = "#4B92C8";
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.target.style.textDecoration = "none";
                                                                                e.target.style.color = "#000";
                                                                            }}
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    marginBottom: "0px",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                {data.name &&
                                                                                    (data.name.length > 12
                                                                                        ? data.name.slice(0, 12) + "..."
                                                                                        : data.name)}
                                                                            </p>
                                                                        </a>
                                                                    </Tooltip>
                                                                </div>
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }}>
                                                                <button
                                                                    onClick={() => handleLogin(data._id)}
                                                                    style={{
                                                                        backgroundColor: "#4B92C8",
                                                                        color: "#fff",
                                                                        padding: "7px 14px",
                                                                        borderRadius: "8px",
                                                                        border: "none",
                                                                        outline: "none",
                                                                        textDecoration: "none",
                                                                        fontSize: "13px",
                                                                        fontWeight: "500",
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        minWidth: "70px",
                                                                        cursor: "pointer",
                                                                        transition: "all 0.25s ease",
                                                                        boxShadow: "0 2px 2px rgba(75,146,200,0.25)",
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.backgroundColor = "#357AB8";
                                                                        e.target.style.transform = "translateY(-1px)";
                                                                        e.target.style.boxShadow =
                                                                            "0 4px 12px rgba(75,146,200,0.35)";
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.backgroundColor = "#4B92C8";
                                                                        e.target.style.transform = "translateY(0px)";
                                                                        e.target.style.boxShadow =
                                                                            "0 2px 8px rgba(75,146,200,0.25)";
                                                                    }}
                                                                >
                                                                    Login
                                                                </button>
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle10">
                                                                {data?.resume?.PersonalDetails?.minimumRate ? "$" + data?.resume?.PersonalDetails?.minimumRate + " per hour" : "Not Available"}
                                                            </td>

                                                            <td style={{ fontSize: "14px", minWidth: "150px" }} className="tableheadingstyle">
                                                                <Tooltip title={<Typography sx={{ fontSize: "16px" }}>{data.email}</Typography>} arrow disableHoverListener={data.email.length <= 16}>
                                                                    <p style={{ marginBottom: "0px", cursor: "pointer" }}>{data.email && <> {data.email.length > 16 ? data.email.slice(0, 16) + "..." : data.email} </>}</p>
                                                                </Tooltip>
                                                            </td>

                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle10">
                                                                {data.phone ? ("+" + data?.resume?.PersonalDetails?.countryCode + " " + data.phone) : "Not Available"}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle10">
                                                                {data.phone ? data.city : "Not Available"}
                                                            </td>
                                                            <td style={{ fontSize: "14px", minWidth: "140px" }} className="tableheadingstyle9">
                                                                {data.dataAdded.slice(8, 10) + " " + MONTH_DETAILS[parseInt(data.dataAdded.slice(5, 7), 10)] + "' " + data.dataAdded.slice(2, 4)}
                                                            </td>
                                                            <td style={{ textAlign: "center", verticalAlign: "middle", padding: "7px 8px" }}>
                                                                <div
                                                                    className="dropdown3"
                                                                    style={{
                                                                        borderRadius: "5px",
                                                                        border: "solid 1px #4B92C8",
                                                                        margin: "0 auto",
                                                                        display: "inline-block",
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="btn dropdown-toggle"
                                                                        type="button"
                                                                        data-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        onClick={() => idSelector(data._id)}
                                                                        style={{ fontSize: "15px", width: "100px" }}
                                                                    >
                                                                        {data.active == false ? "De-active" : "Active"}
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-light px-2 custom-dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                                                        {data.active == false ? (
                                                                            <li>
                                                                                <a className="dropdown-item border text-center py-2" style={{ backgroundColor: "#4B92C8", color: "white", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }} onClick={ActiveUser}>
                                                                                    Active
                                                                                </a>
                                                                            </li>
                                                                        ) : (
                                                                            <li>
                                                                                <a className="dropdown-item border text-center py-2" style={{ backgroundColor: "#4B92C8", color: "white", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }} onClick={DeActiveUser}>
                                                                                    De-active
                                                                                </a>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }}>
                                                                <LuClipboardEdit className="docIcon" style={{ fontSize: "21px", color: "#4B92C8" }} onClick={() => fetchData(data._id)} data-bs-toggle="modal" data-bs-target="#exampleModal" />
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle deletehovering">
                                                                <RiDeleteBinLine className="docIcon" style={{ fontSize: "23px", color: "#646464" }} onClick={() => handleDeleteConfirmation(data._id)} />
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle18">
                                                                {countHourlyJobs(data.appliedJobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle18">
                                                                {countFixedCost(data.appliedJobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle18">
                                                                {data.connectSpentJobSeeker ? data.connectSpentJobSeeker : 0}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle18">
                                                                {" "}
                                                                {countRejectedJobs(data.appliedJobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle18">
                                                                {countShortlistedJobs(data.appliedJobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle17">
                                                                {countHiredJobs(data.appliedJobs)}
                                                            </td>
                                                            <td>
                                                                <div className="tableheadingstyle25 editableconnectcredit" style={{ fontSize: "14px", textAlign: "center" }} contentEditable onKeyDown={(e) => handleKeyDown3(e, data._id)} onBlur={(e) => handleBlur(e, data._id)}>
                                                                    {data.connectCredit}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle25 editableconnectcredit" contentEditable onKeyDown={(e) => handleKeyDown4(e, data._id)} onBlur={(e) => handleBlur2(e, data._id)}>
                                                                    {data.connectSpent}
                                                                </div>
                                                            </td>

                                                            <td style={{ fontSize: "14px", textAlign: "center", minWidth: "300px" }} className="tableheadingstyle17">
                                                                {data?.resume?.AddressDetail && (
                                                                    <Tooltip
                                                                        title={
                                                                            <Typography sx={{ fontSize: "16px" }}>
                                                                                {(() => {
                                                                                    const addressParts = [data?.resume?.AddressDetail?.address, data?.resume?.AddressDetail?.address2, data?.resume?.AddressDetail?.city, data?.resume?.AddressDetail?.state, data?.resume?.AddressDetail?.code].filter((part) => part && part.trim() !== "");

                                                                                    return addressParts.length > 0 ? addressParts.map((part, index) => (index === addressParts.length - 1 ? part : `${part},`)).join(" ") : "Not Available";
                                                                                })()}
                                                                            </Typography>
                                                                        }
                                                                        arrow
                                                                    >
                                                                        <span>
                                                                            {(() => {
                                                                                const addressParts = [data?.resume?.AddressDetail?.address, data?.resume?.AddressDetail?.address2, data?.resume?.AddressDetail?.city, data?.resume?.AddressDetail?.state, data?.resume?.AddressDetail?.code].filter((part) => part && part.trim() !== "");

                                                                                const fullAddress = addressParts.map((part, index) => (index === addressParts.length - 1 ? part : `${part},`)).join(" ");

                                                                                return fullAddress.length > 35 ? `${fullAddress.slice(0, 35)}...` : fullAddress || "Not Available";
                                                                            })()}
                                                                        </span>
                                                                    </Tooltip>
                                                                )}

                                                                {!data?.resume?.AddressDetail && <span>Not Available</span>}
                                                            </td>

                                                            <td style={{ fontSize: "14px", textAlign: "center", minWidth: "150px" }} className="tableheadingstyle17">
                                                                {data?.resume?.IdentityDetails?.frontPhoto?.url && (
                                                                    <a target="_blank" style={{ color: "#4b92c8", textDecoration: "underline" }} href={data?.resume?.IdentityDetails?.frontPhoto?.url}>
                                                                        Front IMG
                                                                    </a>
                                                                )}
                                                                &nbsp;&nbsp;
                                                                {/* {data?.resume?.IdentityDetails?.frontPhoto?.url && <br />} */}
                                                                {data?.resume?.IdentityDetails?.backPhoto?.url && (
                                                                    <a target="_blank" style={{ color: "#4b92c8", textDecoration: "underline" }} href={data?.resume?.IdentityDetails?.backPhoto?.url}>
                                                                        Back IMG
                                                                    </a>
                                                                )}
                                                                {!data?.resume?.IdentityDetails?.backPhoto?.url && !data?.resume?.IdentityDetails?.backPhoto?.url && <span>Not Available</span>}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center", minWidth: "150px" }} className="tableheadingstyle17">
                                                                {data?.resume?.DocDetails?.length > 0 && data?.resume?.DocDetails[0]?.url ? (
                                                                    <a target="_blank" style={{ color: "#4b92c8", textDecoration: "underline" }} href={data.resume.DocDetails[0].url}>
                                                                        Document
                                                                    </a>
                                                                ) : (
                                                                    <span>Not Available</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            ) : (
                                                <>
                                                    <p style={{ padding: "15px  20px", minWidth: "200px", paddingBottom: "10", color: "red" }}>No data found!</p>
                                                </>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div
                            className="pagination"
                            style={{
                                width: "100%",
                                maxWidth: "1200px",
                                marginTop: "-40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "10px",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "14px",
                                    color: "#555",
                                    fontWeight: "500",
                                    paddingLeft: "3px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                Page {currentPage} of {totalPages}
                                &nbsp;|&nbsp;
                                Showing {Math.min(currentPage * 20, totalItem)} of {totalItem} entries
                            </div>
                            <div style={{ textAlign: "center", flex: 1 }}>
                                {totalPages > 1 && (
                                    <PaginationWithLastButton
                                        totalPages={totalPages}
                                        currentPage={currentPage}
                                        onPageChange={setCurrentPage}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="table-box table-responsive border borderremove px-0">
                            <table className="applications table" style={{ marginBottom: "0px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Freelancers</th>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Employers</th>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Hourly Projects</th>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Fixed Cost Projects</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalFreelancers}</div>
                                        </td>

                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalEmployers}</div>
                                        </td>
                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalHourlyProject}</div>
                                        </td>
                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalFixedCostProject}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>

            {/* EDIT PROFILE MODEL */}

            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
                <div
                    className="modal-dialog custom-modal-dialog"
                    style={{
                        backgroundColor: "white",
                        height: "94vh",
                        borderRadius: "10px",
                        overflow: "hidden",
                    }}
                >
                    <div
                        className="modal-content py-3 custom-scrollbarresume borderremove123"
                        ref={borderRemoveRef}
                        style={{
                            overflowY: "auto",
                            height: "98%",
                            backgroundColor: "white",
                            borderColor: "white",
                        }}
                    >
                        <div style={{ padding: "10px", textAlign: "end", zIndex: 100 }}>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>

                        <div className="modal-body">
                            <div className="step-content">
                                <p
                                    className="title text-center mx-auto pb-3"
                                    style={{
                                        color: "#444343",
                                        marginTop: "10px",
                                        marginBottom: "15px",
                                        fontSize: "20px",
                                        fontWeight: "500",
                                    }}
                                >
                                    Personal Details
                                </p>

                                <div className="text-center mb-4">
                                    <div style={{ position: "relative", display: "inline-block" }}>
                                        <label htmlFor="admin-photo-upload" style={{ cursor: "pointer" }}>
                                            <div
                                                className="rounded-circle"
                                                style={{
                                                    width: "150px",
                                                    height: "150px",
                                                    backgroundColor: "#eaeaea",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    overflow: "hidden",
                                                    borderRadius: "50%",
                                                    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                                                    border: "4px solid white",
                                                }}
                                            >
                                                {candidate?.photo !== "" ? (
                                                    <img
                                                        src={candidate?.photo?.url || candidate?.photo}
                                                        alt=""
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            borderRadius: "50%",
                                                        }}
                                                    />
                                                ) : (
                                                    <span style={{ color: "#aaa" }}>Upload Photo</span>
                                                )}
                                            </div>
                                        </label>

                                        {/* Pencil Icon */}
                                        <div
                                            onClick={() =>
                                                document.getElementById("admin-photo-upload").click()
                                            }
                                            style={{
                                                position: "absolute",
                                                bottom: "12%",
                                                right: "16px",
                                                backgroundColor: "white",
                                                borderRadius: "50%",
                                                padding: "5px",
                                                cursor: "pointer",
                                                zIndex: 10,
                                                boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                                                border: "2px solid white",
                                            }}
                                        >
                                            <HiOutlinePencilAlt
                                                style={{
                                                    color: "#2092c7",
                                                    fontSize: "21px",
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <input
                                        type="file"
                                        id="admin-photo-upload"
                                        style={{ display: "none" }}
                                        onChange={handlePhotoChangeForAdmin}
                                        accept=".jpeg,.jpg,.png,.gif,.bmp"
                                        multiple={false}
                                        data-show-preview="false"
                                        data-show-upload="false"
                                        capture="camera"
                                    />
                                </div>

                                <div className="sectionn ml-auto px-2">
                                    <div className="mx-auto">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group my-2">
                                                    <label style={{ fontSize: "15px" }}>First Name</label>
                                                    <input
                                                        className="ModelInput form-control"
                                                        style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                        placeholder="Enter first name"
                                                        name="firstName"
                                                        value={candidate.firstName}
                                                        onChange={handleUserChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-6">
                                                <div className="form-group my-2">
                                                    <label style={{ fontSize: "15px" }}>Last Name</label>
                                                    <input
                                                        className="ModelInput form-control"
                                                        style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                        placeholder="Enter last name"
                                                        name="lastName"
                                                        value={candidate.lastName}
                                                        onChange={handleUserChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group mt-4 mb-2">
                                            <label style={{ fontSize: "15px" }}>Minimum rate ($/hour)</label>
                                            <input
                                                className="ModelInput form-control"
                                                style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                placeholder="eg. 10"
                                                name="minimumRate"
                                                value={candidate.minimumRate}
                                                onChange={handleUserChange}
                                            />
                                        </div>

                                        <div className="form-group mt-4 mb-2">
                                            <label style={{ fontSize: "15px" }}>Email</label>
                                            <input
                                                type="email"
                                                className="ModelInput form-control"
                                                style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                name="email"
                                                value={candidate.email}
                                                onChange={handleUserChange}
                                                readOnly
                                            />
                                        </div>

                                        <div className="form-group mt-4 mb-2">
                                            <label style={{ fontSize: "15px" }}>Professional Title</label>
                                            <input
                                                className="ModelInput form-control"
                                                style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                placeholder="MERN Stack"
                                                name="professionalTitle"
                                                value={candidate.professionalTitle}
                                                onChange={handleUserChange}
                                            />
                                        </div>

                                        <div
                                            className="form-group contactAndCode"
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "flex-end",
                                                width: "100%",
                                                gap: "5px",
                                                marginTop: "20px",
                                            }}
                                        >
                                            <div style={{ width: "30%" }}>
                                                <label style={{ fontSize: "15px", margin: "0px" }}>
                                                    Country Code
                                                </label>

                                                <div className="countryWrapper">
                                                    <div className="countryWrapper">
                                                        <CountryCodeDropDownForProfile
                                                            setSelectedCountry={handleCandidateCountrySelect}
                                                            selectedCountryValue={candidate.countryCode}
                                                            disabled={candidate.verified}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ width: "70%" }}>
                                                <label style={{ fontSize: "15px", margin: "0px" }}>Contact Number</label>
                                                <input
                                                    type="text"
                                                    className="ModelInput form-control"
                                                    style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                    name="phone"
                                                    value={candidate.phone}
                                                    onChange={handleCandidatePhoneChange}
                                                    readOnly={candidate.verified}
                                                    disabled={candidate.verified}
                                                />
                                            </div>

                                            {candidate.verified && (
                                                <img src={verified} alt="Verified icon" style={{ width: "30px", height: "30px", marginBottom: "10px" }} />
                                            )}
                                        </div>
                                        {showOtpActions && !candidate.verified && (
                                            <div style={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginTop: "10px",
                                            }}>
                                                {!otpSent ? (
                                                    <button type="button" onClick={sendOtpForAdminCandidate} className="saveUpdate">
                                                        {loading ? <Spinner /> : "Send OTP"}
                                                    </button>
                                                ) : (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                            width: "100%",
                                                            marginTop: "12px",
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", gap: "4px" }}>
                                                            {["digitOne", "digitTwo", "digitThree", "digitFour"].map((digit, index) => (
                                                                <input
                                                                    key={digit}
                                                                    ref={(el) => (inputRefs.current[index] = el)}
                                                                    type="text"
                                                                    value={otp[digit]}
                                                                    onChange={(e) => handleOtpChange(e, digit, index)}
                                                                    maxLength={1}
                                                                    style={{
                                                                        width: "35px",
                                                                        height: "35px",
                                                                        textAlign: "center",
                                                                        fontSize: "16px",
                                                                        border: "1px solid #ccc",
                                                                        borderRadius: "5px",
                                                                    }}
                                                                />
                                                            ))}
                                                        </div>

                                                        <button
                                                            type="button"
                                                            onClick={verifyOtpForAdminCandidate}
                                                            className="saveUpdate"
                                                            style={{
                                                                minWidth: "125px",
                                                                height: "35px",
                                                                margin: "0px",
                                                                padding: "0px 12px",
                                                            }}
                                                        >
                                                            {loading ? <Spinner /> : "Verify OTP"}
                                                        </button>

                                                        <div style={{ marginLeft: "auto", minWidth: "110px", textAlign: "right" }}>
                                                            {isResendDisabled ? (
                                                                <span style={{ color: "#1e9cf0", fontSize: "12px" }}>
                                                                    Resend OTP in : 00:{timer < 10 ? `0${timer}` : timer}
                                                                </span>
                                                            ) : (
                                                                <span
                                                                    style={{
                                                                        color: "#1e9cf0",
                                                                        cursor: "pointer",
                                                                        fontSize: "13px",
                                                                    }}
                                                                    onClick={sendOtpForAdminCandidate}
                                                                >
                                                                    Resend OTP
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className="form-group mt-4 mb-2">
                                            <label style={{ fontSize: "15px" }}>Location</label>
                                            <input
                                                className="ModelInput form-control"
                                                style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                name="address"
                                                value={candidate.address}
                                                onChange={handleUserChange}
                                            />
                                        </div>

                                        <div className="form-group mt-4 mb-2">
                                            <label style={{ fontSize: "15px" }}>Video Introduction (YouTube Url)</label>
                                            <div style={{ fontSize: "13px" }}>Optional</div>
                                            <input
                                                className="ModelInput form-control"
                                                style={{ fontSize: "15px", paddingTop: "18px", paddingBottom: "18px" }}
                                                placeholder="eg. youtube link"
                                                name="videoIntroduction"
                                                value={candidate.videoIntroduction}
                                                onChange={handleUserChange}
                                            />
                                        </div>

                                        {candidate.videoIntroduction && (
                                            <div className="form-group mt-4 mb-2">
                                                <iframe
                                                    width="100%"
                                                    height="250"
                                                    style={{ borderRadius: "10px" }}
                                                    src={candidate.videoIntroduction.replace("watch?v=", "embed/").replace("youtu.be/", "www.youtube.com/embed/").split("?")[0]}
                                                    title="Video Introduction"
                                                    frameBorder="0"
                                                    allowFullScreen
                                                />
                                            </div>
                                        )}

                                        <div className="form-group mt-4 mb-2">
                                            {candidate.profileCategories.map((category, index) => (
                                                <div key={category.id || index} style={{ marginTop: index !== 0 ? "10px" : "0px" }}>
                                                    <label style={{ fontSize: "15px" }}>Profile category</label>
                                                    <Select
                                                        options={profiles.map((profile) => ({
                                                            value: profile,
                                                            label: profile,
                                                        }))}
                                                        placeholder={<div style={{ fontSize: "13px" }}>Select profile</div>}
                                                        value={
                                                            category.profile
                                                                ? { value: category.profile, label: category.profile }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            handleCandidateProfileSelect(selectedOption, index)
                                                        }
                                                    />

                                                    <div style={{ marginTop: "10px" }}>
                                                        <label style={{ fontSize: "15px" }}>Profile Specialization</label>
                                                        <Select
                                                            isMulti
                                                            options={
                                                                specializations[category.profile]?.map((spec) => ({
                                                                    value: spec,
                                                                    label: spec,
                                                                })) || []
                                                            }
                                                            placeholder={<div style={{ fontSize: "13px" }}>Select specializations</div>}
                                                            value={category.specializations.map((spec) => ({
                                                                value: spec,
                                                                label: spec,
                                                            }))}
                                                            onChange={(selectedOptions) => {
                                                                handleCandidateProfileCategoryChange(
                                                                    index,
                                                                    "specializations",
                                                                    selectedOptions.map((option) => option.value)
                                                                );
                                                            }}
                                                            isDisabled={loadingSpecializations[index]}
                                                        />
                                                    </div>

                                                    {index > 0 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger mt-2"
                                                            onClick={() => removeCandidateProfileCategory(index)}
                                                        >
                                                            Remove
                                                        </button>
                                                    )}
                                                </div>
                                            ))}

                                            {candidate.profileCategories.length < 3 && (
                                                <p
                                                    className="btn p-0"
                                                    style={{
                                                        color: "#0196C5",
                                                        fontSize: "15px",
                                                        float: "right",
                                                        marginTop: "8px",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={addCandidateProfileCategory}
                                                >
                                                    + Add More
                                                </p>
                                            )}
                                        </div>

                                        <div className="form-group mt-5 mb-2">
                                            <label style={{ fontSize: "15px" }}>Profile Summary</label>
                                            <textarea
                                                className="ModelInput form-control"
                                                style={{
                                                    fontSize: "15px",
                                                    lineHeight: "20px",
                                                    borderColor: candidate.profileSummary.length < 5000 ? "gray" : "red",
                                                }}
                                                rows="6"
                                                placeholder="Short description of work done..."
                                                value={candidate.profileSummary}
                                                onChange={handleUserChange}
                                                maxLength="5000"
                                                name="profileSummary"
                                            />
                                        </div>

                                        <p className="text-end" style={{ fontSize: "13px", color: "gray" }}>
                                            Please limit your input to 5000 characters or less
                                        </p>

                                        <div className="form-group mt-4 mb-2">
                                            <label>Availability</label>
                                            <select
                                                className="form-select mt-1"
                                                style={{ fontSize: "15px", paddingTop: "8px", paddingBottom: "6px" }}
                                                name="availability"
                                                value={candidate.availability}
                                                onChange={handleUserChange}
                                            >
                                                <option value="">Select Availability</option>
                                                <option value="Immediate">Immediate</option>
                                                <option value="Within 1 Week">Within 1 Week</option>
                                                <option value="Within 2 Weeks">Within 2 Weeks</option>
                                                <option value="Within 3 Weeks">Within 3 Weeks</option>
                                                <option value="Within 4 Weeks">Within 4 Weeks</option>
                                                <option value="Within 5 Weeks">Within 5 Weeks</option>
                                                <option value="Within 6 Weeks">Within 6 Weeks</option>
                                                <option value="Within 7 Weeks">Within 7 Weeks</option>
                                                <option value="Within 8 Weeks">Within 8 Weeks</option>
                                            </select>
                                        </div>

                                        <div style={{ marginTop: "25px", textAlign: "end" }}>
                                            <button onClick={handleUpdate} className="saveUpdate">
                                                {loading ? <Spinner /> : <span>Update</span>}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Popup open={showModal} modal closeOnDocumentClick={false}>
                <div className="overlay" style={{ background: "rgba(0, 0, 0, 0.4)" }}>
                    <div className="popup-containernew">
                        <div className="success-message mx-3" style={{ marginBottom: "10px" }}>
                            Are you sure you want to delete? This action cannot be undone.
                        </div>
                        <div style={{ display: "flex", alignItems: "center", alignSelf: "center", gap: "10px", marginBottom: "15px" }}>
                            <button className="employerbuttonbacktodash" onClick={handleCancelDelete}>
                                Cancel
                            </button>
                            <button className="employerbuttontobuyinformation" style={{ backgroundColor: "#ED5E68" }} onClick={handleConfirmDelete}>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </Popup>
            <ToastContainer position="top-center" autoClose={10000} />
        </>
    );
}

export default AdminCandidates;
